import React, { useEffect, useState } from "react";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import Translator from "Languages/Utility/Translator";
import { satc_priceSupervisor } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { useTranslation } from "react-i18next";
import { useSetState } from "Helpers/Hooks";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Grid from "@material-ui/core/Grid";
import { read } from "Helpers/LocalStorage";
import { Skeleton } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { getAccountingPriceSupervisor, getActivePeriods } from "Stores/actions";
import BackDropLoading from "Components/BackDropLoading2/BackDropLoading";
import PageTitle from "Components/PageTitle_IconCircle/PageTitle";
import AddSupervisor from "./AddSupervisor";

export default function Supervisor() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [sizePerPage, setSizePerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [tblData, setTblData] = useState();
  const [columns, setColumns] = useState([]);
  const {
    accountPriceSupervisor,
    activePeriods,
    getPriceSupervisorAgain,
    pagination,
  } = useSelector((state) => ({
    accountPriceSupervisor: state.saAccounts.accountPriceSupervisor,
    activePeriods: state.saAccounts.activePeriods,
    getPriceSupervisorAgain: state.saAccounts.getPriceSupervisorAgain,
    pagination: state.saAccounts.pagination,
  }));
  const [controls, setControls] = useSetState({
    periods: {
      type: "select",
      selectItems: [],
      value: null,
      validation: null,
    },
  });

  useEffect(() => {
    onEnter();
  }, []);

  const onEnter = async () => {
    setLoading(true);
    const _columns = [...satc_priceSupervisor];
    _columns[7].hidden = !read("FormPriceSuperAdmin").accessUpdate;
    _columns[8].hidden = !read("FormPriceSuperAdmin").accessDelete;
    setColumns(_columns);
    await getPeriods();
    await getPrices(1, sizePerPage);
    setLoading(false);
  };

  const getPrices = async (_page, _sizePerPage, periodId = null) => {
    setLoading(true);
    return new Promise(async (resolve) => {
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        Limit: _sizePerPage,
        Page: _page,
        ...periodId,
      };
      await dispatch(getAccountingPriceSupervisor(params));
      setLoading(false);
      resolve(true);
    });
  };

  const getPeriods = async () => {
    return new Promise(async (resolve) => {
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
      };
      await dispatch(getActivePeriods(params));
      resolve(true);
    });
  };

  useEffect(() => {
    if (accountPriceSupervisor) {
      setTblData(accountPriceSupervisor);
      setSizePerPage(pagination.Limit);
      setCurrentPage(pagination.Page);
      setTotal(pagination.Total);
    }
  }, [accountPriceSupervisor]);

  useEffect(() => {
    if (activePeriods) {
      const defArr = [{ label: t("chooseOnePeriod"), value: -1 }];
      const selectItems = activePeriods.map((child) => {
        return {
          label: child.Name,
          value: child.Id,
        };
      });
      setControls({ periods: { selectItems: defArr.concat(selectItems) } });
      setControls({ periods: { value: defArr[0] } });
      // setPeriodsReady(true);
    }
  }, [activePeriods]);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      await getPrices(page, sizePerPage);
    }
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    await tblRefresh(
      1,
      sizePerPage,
      controlName === "periods" ? value.value : null
    );
  };

  useEffect(() => {
    if (getPriceSupervisorAgain) {
      (async () => {
        await tblRefresh(currentPage, sizePerPage);
      })();
    }
  }, [getPriceSupervisorAgain]);

  const tblRefresh = async (innerPage, innerSizePerPage, period = null) => {
    let dataSearch = {};
    const { factors, periods } = controls;
    if (period) {
      if (period !== -1) dataSearch.PeriodId = period;
    } else {
      if (periods.value.value !== -1) dataSearch.PeriodId = periods.value.value;
    }
    await getPrices(innerPage, innerSizePerPage, dataSearch);
  };

  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button my-3">
        <PageTitle title={<Translator id={"supervisor"} />} />
        <div className="top-buttons">
          <AddSupervisor disabled={loading} />
        </div>
      </div>
      <MuiPaper>
        <Grid container className="mb-2">
          <Grid item md={3} sm={6} xs={12}>
            {!loading ? (
              <MuiAutoComplete
                autoSelect={true}
                options={controls.periods.selectItems}
                label={<Translator id="periods" />}
                value={controls.periods.value}
                onChange={autoCompleteHandler}
                id={"periods"}
              />
            ) : (
              <Skeleton variant="text" className="p-2" animation="wave" />
            )}
          </Grid>
        </Grid>
        {columns && columns.length !== 0 && (
          <RemoteTable
            data={tblData}
            columns={columns}
            page={currentPage}
            sizePerPage={sizePerPage}
            totalSize={total}
            onTableChange={onTableChange}
          />
        )}
      </MuiPaper>
    </>
  );
}
